// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AppointmentListPagingResultModel from '../../model/appointment-list-paging-result-model';
import AppointmentListPagingResultDTO from '../dto/appointment-list-paging-result-dto';
import dtoSchema from '../schemas/appointment-list-paging-result-schema';
import AppointmentListModel from '../../model/appointment-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class AppointmentListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AppointmentListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => AppointmentListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: AppointmentListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<AppointmentListPagingResultDTO>): AppointmentListPagingResultModel;
  static toModel(dto: DeepPartial<AppointmentListPagingResultDTO> | undefined | null): AppointmentListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<AppointmentListPagingResultDTO> | undefined | null): AppointmentListPagingResultModel | undefined {
    return dto ? new AppointmentListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AppointmentListPagingResultModel> | AppointmentListPagingResultModel): AppointmentListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as AppointmentListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AppointmentListPagingResultModel, can not map to AppointmentListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
